import { HistorySharp } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Button, Grid, IconButton } from '@mui/material';
import { TFunction } from 'i18next';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultAssignmentIcon, EDataTableType } from '../data/Constants';

//Tree Parent icon
export const AddCircle = (): ReactElement => {
  return <AddCircleIcon className="defaultExpandIcon zoom80" />;
};

//Tree Children icon
export const RemoveCircle = (): ReactElement => {
  return <RemoveCircleIcon className="defaultCollapseIcon zoom80" />;
};

//tree last level icon
export const RemoveCircleEnd = (): ReactElement => {
  return <RemoveCircleIcon className="defaultEndIcon zoom80" />;
};

/**
 *Check the association  and return the Default Icon element
 * @param { IPropertyAssociation } associations property associations
 * @param { string } defaultValue the default value for the property
 * @param {string} code current property code
 * @param { TFunction } t the translation function
 * @returns { React.JSX.Element } return the Default Icon element
 */
export const getDefaultIcon = (
  associations: { [key: string]: string | null },
  defaultValue: string | null,
  code: string,
  t: TFunction
): React.JSX.Element => {
  if (
    (!associations?.[code] && defaultValue) ||
    (defaultValue && associations?.[code]?.toLowerCase() === defaultValue?.code?.toLowerCase())
  ) {
    return (
      <Grid title={t('labels.defaultAssignment')} className="defaultIcon">
        {DefaultAssignmentIcon}
      </Grid>
    );
  }
  return <></>;
};

//Refresh Button
export const RefreshButton = (props: { handleRefresh: () => void }): ReactElement => {
  const { t } = useTranslation();
  return (
    <Button
      className="refresh-button text-capitalize common-btn ml-1"
      color="primary"
      variant="text"
      startIcon={<RefreshIcon />}
      onClick={props.handleRefresh}
    >
      {t('labels.refresh')}
    </Button>
  );
};

export const HistoryButton = (props: {
  showPropertyHistoryDialog: (tableType: EDataTableType | '', open: boolean) => void;
  hideLabel?: boolean;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <IconButton
      id={`property-history-icon`}
      className="history-button text-capitalize"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      onClick={(): void => {
        props.showPropertyHistoryDialog(EDataTableType.AllPropertiesHistory, true);
      }}
    >
      <HistorySharp sx={{ fontSize: '1.8rem' }}></HistorySharp>
      <span>{!props.hideLabel && t('labels.history')}</span>
    </IconButton>
  );
};
